import { Component, OnInit } from '@angular/core';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { Asset } from 'src/app/models/asset';
import { AssetFileSpecification } from 'src/app/models/assetFileSpecification';
import { AssetFile } from 'src/app/models/assetFile';
import { Quality } from 'src/app/models/quality';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { User } from 'src/app/models/user';
import { AssetAttributes } from 'src/app/models/assetAttributes';
import { ContactInfo } from 'src/app/models/contactInfo';
import { Observable } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-upload-asset',
  templateUrl: './upload-asset.component.html',
  styleUrls: ['./upload-asset.component.css']
})
export class UploadAssetComponent implements OnInit {

  asset: Asset = new Asset();
  folderpath: string;
  assetFileSpecifaction: AssetFileSpecification = new AssetFileSpecification();
  assetFile: AssetFile = new AssetFile();
  files: NgxFileDropEntry[] = [];
  threeDfile: any;
  texturesFiles: any[] = [];
  fileQuality = "High";
  texturequality = "High";
  loader = false;
  uploadPercentDone = 0;
  loggedInUser: User = new User();
  assetAttributes: AssetAttributes = new AssetAttributes();
  primaryContactInfo: ContactInfo = new ContactInfo();
  radioButtonValue: any;

  uploadWarningText = "Warning! Closing the browser will terminate the upload process";

  public threeFileTypes: string[];
  public readonly textureFilesFormats = ['mtl', 'exr', 'psd', 'bmp', 'gif', 'jpg', 'tif', 'png', 'tga', 'tpl', 'pvr', 'vtf', 's3tc','pdf','json'];
  supportedImageFormats = ['jpg', 'jpeg', 'png', 'tiff', 'gif', 'bmp'];
  showPrimaryContactDiv = false;
  uploadProcess = false;
  noFilerError = false;
  currentFolderDetails: any;
  assetNameExists = false;
  assetTagError = false;

  unsupportedFiles = [];
  primaryContactNameControl = new FormControl('', [Validators.required]);
  primaryContactEmailControl = new FormControl('', [Validators.email, Validators.required, Validators.pattern('.*@siemens-healthineers.com')]);
  assetNameControl = new FormControl('', [Validators.required, Validators.pattern(new RegExp('^[a-z\\d ]+([-_]?[a-z\\d ]+)*$', 'i'))]);
  isUploadClicked = false;
  selectedPreviewImages: string[];
  modifiedPreviewImages: string[];
  deleteImg: any;
  deletePath: string;
  unsupportedImageErrorMessage: string;
  previewImage: File[] = [];
  preview = [];
  uploadEnable: boolean = true;
  theme_color: any;


  constructor(public httpService: HttpService, private router: Router, private userService: UserService, public location: Location,
    public activateRoute: ActivatedRoute) { }

  ngOnInit() {
    // Get ThreedFileFormats
    this.httpService.getFileFormats().then(response => {
      this.threeFileTypes = response.threedFilesFormats;
    });
    this.httpService.themeChange.subscribe(
      data => {
        this.theme_color = data.themeType;
      }
    );
    this.httpService.currentSearchPath.subscribe(path => {
      this.folderpath = path;
    });
    if (!this.folderpath) {
      this.activateRoute.params.subscribe(param => {
        this.folderpath = param.folder;
      });
    }
    this.httpService.clear3DCache = false;
    if (!this.httpService.folder) {
      sessionStorage.clear();
      this.router.navigateByUrl("/login");
      return;
    }
    this.asset = new Asset();
    this.asset.name = "";

    this.assetFileSpecifaction = new AssetFileSpecification();
    // this.assetFileSpecifaction.interaction = true;
    this.uploadPercentDone = 0;
    this.loggedInUser = this.userService.loggendInUser;
    
    if (this.loggedInUser.userEmailId == "") {
      this.loggedInUser = JSON.parse(sessionStorage.getItem("userinfo")) as User;
    }

    if (this.httpService.asset && this.httpService.asset._id && (this.httpService.newVersionFlag || this.httpService.newExtensionFlag || this.httpService.updateAssetFile)) {
      this.asset = this.httpService.asset;
      this.assetAttributes = this.asset.attributes;
      this.assetAttributes.uploader = this.loggedInUser.userEmailId;
      if (this.httpService.updateAssetFile) {
        this.assetFile = this.httpService.selectedAssetFile;
        this.assetFileSpecifaction = this.assetFile.specification;

        const quality: Quality = new Quality();
        this.fileQuality = quality.qualityString[this.assetFileSpecifaction.fileQuality.toString()];
        this.texturequality = quality.qualityString[this.assetFileSpecifaction.textureQuality.toString()];

        this.fetchFileDetails();
      }
      this.showPrimaryContactDiv = true;
    } else {
      this.assetAttributes.uploader = this.loggedInUser.userEmailId;
      this.primaryContactInfo.emailId = this.loggedInUser.userEmailId;
      this.primaryContactInfo.name = this.loggedInUser.name;
      this.asset.attributes = this.assetAttributes;
      this.asset.attributes.primaryContact = this.primaryContactInfo;

      this.asset.attributes.productStatus = 0;
      this.getFolderDetails();
    }
    this.primaryContactNameControl = new FormControl(this.asset.attributes.primaryContact.name, [Validators.required]);
    this.primaryContactEmailControl = new FormControl(this.asset.attributes.primaryContact.emailId, [Validators.email, Validators.required, Validators.pattern('.*@siemens-healthineers.com')]);
    if (this.httpService.newVersionFlag || this.httpService.newExtensionFlag || this.httpService.updateAssetFile) {
      this.assetNameControl = new FormControl(this.asset.name, [Validators.required, Validators.pattern(new RegExp('^[a-z\\d ]+([-_]?[a-z\\d ]+)*$', 'i'))]);
    }

    this.fetch3DImages();
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.uploadProcess)
      return confirm("Want to navigate without Upload?");
    else return true;
  }

  dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    console.log(this.files);
    if(this.files.length>0){
      this.uploadEnable = false;
    }
    this.unsupportedFiles = [];
    let texturesFiles = [];
    //get all 3D files uploaded by the user
    let all3DFiles = files.filter(
      file => {
        // debugger;
        if (this.threeFileTypes.indexOf(file.relativePath.split('.')[file.relativePath.split('.').length - 1].toLowerCase()) > -1) {
          return true;
        }
        else if (this.textureFilesFormats.indexOf(file.relativePath.split('.')[file.relativePath.split('.').length - 1].toLowerCase()) > -1) {
          texturesFiles.push(file);
          return false
        }
        else {
          this.unsupportedFiles.push(`.${file.relativePath.split('.')[file.relativePath.split('.').length - 1]}`);
          return false;
        }
      }
    );

    this.unsupportedFiles = Array.from(new Set(this.unsupportedFiles));

    // const texturesFiles = event.files.filter(
    //   file => 
    //   {
    //     if(this.textureFilesFormats.indexOf(file.relativePath.split('.')[file.relativePath.split('.').length - 1].toLowerCase()) > -1)
    //     return true;
    //    else {
    //      this.unSupportedFiles.push((file.relativePath.split('.')[file.relativePath.split('.').length - 1]));
    //      return false;
    //    }
    //   }0
    // );

    if (files.length > all3DFiles.length + texturesFiles.length) {
      // alert("Some files are not suported.");
      texturesFiles = [];
      all3DFiles = new Array<NgxFileDropEntry>();
      document.getElementById('unsupported').setAttribute('visible', 'true');
    }

    if (this.texturesFiles.length === 0) {
      this.texturesFiles = texturesFiles;
    } else {
      this.texturesFiles = [...this.texturesFiles, ...texturesFiles];
    }

    if (all3DFiles.length === 1) {
      this.threeDfile = all3DFiles[0];
    }
    else if (all3DFiles.length > 1) {
      alert("one 3d object per selection");
    }

    if (null !== this.threeDfile) {
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].removeAttribute('style');
        } else {
          element.removeAttribute('style');
        }
      }
    }
  }

  fileOver(event) {
    console.log(event);
  }

  fileLeave(event) {
    console.log(event);
  }

  fetch3DImages() {
    let asset = this.asset.assetfiles.filter(assetFile => assetFile.versionNo === this.httpService.selectedVersionNumber);
    this.selectedPreviewImages = asset[0].uploadedImageURL;
    this.modifiedPreviewImages = JSON.parse(JSON.stringify(this.selectedPreviewImages));
    this.selectedPreviewImages = this.selectedPreviewImages.map(item => {
      item = 'assets\\' + item;
      return item;
    });
  }

  changeCheckBoxValue(obj, param) {
    //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Don't Delete the comment>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // if (!sessionStorage.getItem("checked") || sessionStorage.getItem("checked") !== "1") {
    //   // data = !data;
    //   obj[param] = !obj[param];
    //   sessionStorage.setItem("checked", "1");
    // } else sessionStorage.setItem("checked", "0");
    setTimeout(() => {
      obj[param] = !obj[param];
    });
  }

  removeTag(tagIndex) {
    this.asset.tags.splice(tagIndex, 1);
  }

  validateTagName(tag: string) {
    this.assetTagError = false;
    if (tag && tag.trim().length >= 1) {
      let regex = new RegExp('^[.]{0,1}([a-z\\d ]+)[#]*([-.]?[a-z\\d ]+)*[#]*([+]{2}[a-z\\d ]+)*[#]*([+]{0,2})$');
      this.assetTagError = !regex.test(tag.toLowerCase().trim());
    }
    return this.assetTagError;
  }

  addTags(tag: string) {
    if (!this.validateTagName(tag)) {
      if (tag.length > 0)
        this.asset.tags.push(tag.toLowerCase());
    }
  }

  upload() {
    if (this.validateAssetForm()) {
      let quality: Quality = new Quality();
      this.assetFileSpecifaction.fileQuality = quality.quality[this.fileQuality];
      this.assetFileSpecifaction.textureQuality = quality.quality[this.texturequality];

      const formData = new FormData();
      if (this.threeDfile.fileEntry && this.threeDfile.fileEntry.isFile) {
        const threeDfileEntry = this.threeDfile.fileEntry as FileSystemFileEntry;
        threeDfileEntry.file((file: File) => {

          //access the real file
          console.log(this.threeDfile.relativePath, file);
          formData.append('threejsmodel', file, this.threeDfile.relativePath.split("/")[this.threeDfile.relativePath.split("/").length - 1]);
          this.assetFileSpecifaction.fileFormat = this.threeDfile.relativePath.split('.')[this.threeDfile.relativePath.split('.').length - 1];

          //console.log("Hi>>>>>>>>>>>>>>>>>>>>>", this.assetFileSpecifaction.fileFormat);
        });
        //console.log("Hi111111");

      } else {

        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = this.threeDfile.fileEntry as FileSystemDirectoryEntry;
        console.log(this.threeDfile.relativePath, fileEntry);
        formData.append('threejsmodel', new Blob([this.threeDfile, this.texturesFiles]),
          this.threeDfile.name);
        if (this.threeDfile.name) {
          this.assetFileSpecifaction.fileFormat = this.threeDfile.name.split('.')[this.threeDfile.name.split('.').length - 1];
        }
      }
      // It was a directory (empty directories are added, otherwise only files)



      let textureFiles = [];

      this.texturesFiles.forEach(
        async textureFile => {
          if (textureFile.fileEntry && textureFile.fileEntry.isFile) {
            const texturefileEntry = textureFile.fileEntry as FileSystemFileEntry;
            texturefileEntry.file((file: File) => {
              let fileName = textureFile.relativePath.split("/")[textureFile.relativePath.split("/").length - 1];
              if ((fileName.split(".")[1]).toLowerCase() === "mtl") {
                fileName = this.threeDfile.fileEntry.name.split(".")[0] + "." + fileName.split(".")[1];
              }
              if (textureFiles.indexOf(fileName) <= -1) {
                formData.append('texture', file, fileName);
                textureFiles.push(fileName)
              }
            });
          } else if (textureFile.name) {
            let fileName = textureFile.name;
            if((fileName.split(".")[1]).toLowerCase() === "mtl"){
              fileName = this.threeDfile.name.split(".")[0] + "." + textureFile.name.split(".")[1];
            }
            if (textureFiles.indexOf(fileName) <= -1) {
              formData.append('texture', textureFile, fileName);
              textureFiles.push(fileName);
            }

          } else {
            // It was a directory (empty directories are added, otherwise only files)
            const fileEntry = this.threeDfile.fileEntry as FileSystemDirectoryEntry;
            console.log(this.threeDfile.relativePath, fileEntry);
          }
        }
      )

      setTimeout(() => {

        let asset = this.asset.assetfiles.filter(assetFile => assetFile.versionNo === this.httpService.selectedVersionNumber);
        if (this.httpService.newExtensionFlag && asset.filter(assetFile => assetFile.specification.fileFormat.toLowerCase() === this.assetFileSpecifaction.fileFormat.toLowerCase()
          && assetFile.specification.textureQuality === this.assetFileSpecifaction.textureQuality
          && assetFile.specification.fileQuality === this.assetFileSpecifaction.fileQuality).length > 0) {
          document.getElementById('alreadyPresent').setAttribute('visible', 'true');
          return;
        }
        this.assetFileSpecifaction.fileType = '3D';
        this.assetFile.specification = this.assetFileSpecifaction;
        // for(let i of JSON.parse(JSON.stringify(this.assetFile.specification))){
        //   this.assetFile.specification[i.charAt(0).toUpperCase()+i.slice(1)] = this.assetFile.specification[i];
        //   delete this.assetFile.specification[i];
        // }
        // this.asset.assetfiles = new Array<AssetFile>();
        //debugger;
        if (!this.asset.assetfiles) {
          this.asset.assetfiles = new Array<AssetFile>();
        }
        if (this.httpService.newExtensionFlag) {
          formData.append('flow', '2');
          this.assetFile.versionNo = this.httpService.selectedVersionNumber;
        } else if (this.httpService.newVersionFlag) {
          formData.append('flow', '1');
        } else {
          formData.append('flow', '0');
        }
        this.asset.assetfiles.push(this.assetFile);

        delete this.asset.inform;



        console.log(JSON.stringify(this.asset, null, 2));


        console.log(formData);
        this.loader = true;
        this.uploadProcess = true;
        if (this.httpService.updateAssetFile) {
          formData.append('assetId', this.asset._id);
          formData.append('assetFile', JSON.stringify(this.assetFile));


          this.httpService.updateFile(`${this.httpService.basePath}/asset/updateassetfiles/${this.userService.loggendInUser.userEmailId}`, formData).subscribe(
            (data: any) => {
              if (data.type === HttpEventType.UploadProgress) {
                // This is an upload progress event. Compute and show the % done:
                const percentDone = Math.round(100 * data.loaded / data.total);
                this.uploadPercentDone = percentDone;
                console.log('>>>>>>>>>>>>>>>>>>>', data);
                console.log(`File is ${this.uploadPercentDone}% uploaded.`);
                if (this.uploadPercentDone >= 100) {
                  // debugger;
                  this.uploadWarningText = "Preparing your Asset"
                  setTimeout(() => {

                    this.router.navigateByUrl(`/val-assets/search/assets/${this.folderpath}/${this.asset._id}`);
                    this.loader = false;
                    this.uploadProcess = false;
                  }, 2000);
                }
              } else if (event instanceof HttpResponse) {
                console.log('File is completely uploaded!');
                console.log(data);
                this.loader = false;
                this.router.navigateByUrl(`/val-assets/search/assets/${this.folderpath}/${this.asset._id}`);
              }

            }, err => {
              console.error(err);
              this.uploadProcess = false;
              this.loader = false;
              this.resetData();
            }, () => {
              this.httpService.asset = null;
              this.resetData();
            }
          )
        } else {
          formData.append('assetinfo', JSON.stringify(this.asset));
          formData.append('parentfolderid', this.httpService.folder._id);
          let uploadProcess = false;
          this.httpService.uploadFile(`${this.httpService.basePath}/asset/upload/${this.userService.loggendInUser.userEmailId}`, formData).subscribe(
            (data: any) => {
              if (data.type === HttpEventType.UploadProgress) {
                // This is an upload progress event. Compute and show the % done:
                const percentDone = Math.round(100 * data.loaded / data.total);
                this.uploadPercentDone = percentDone;
                console.log(data);
                console.log(`File is ${this.uploadPercentDone}% uploaded.`);
                if (this.uploadPercentDone >= 100) {
                  console.log(data);
                  this.uploadWarningText = "Preparing your Asset"
                  uploadProcess = true;
                }
              } else if (event instanceof HttpResponse) {
                console.log('File is completely uploaded!');
                console.log(data);
                this.loader = false;
              } else {
                if (uploadProcess) {
                  console.log('File is completely uploaded!');
                  console.log(data);
                  if (data.body) {
                    setTimeout(() => {
                      this.loader = false;
                      this.uploadProcess = false;
                      this.userService.loggendInUser.assetsUploaded.push(data.body._id);
                      sessionStorage.setItem('userinfo', JSON.stringify(this.userService.loggendInUser));
                      this.router.navigateByUrl(`/val-assets/search/assets/${this.folderpath}/${data.body._id}`);
                    }, 500);
                  }
                }
              }

            }, err => {
              console.error(err);
              this.uploadProcess = false;
              this.loader = false;
              this.httpService.newExtensionFlag = false;
              this.httpService.newVersionFlag = false;
              this.httpService.updateAssetFile = false;
            }, () => {
              this.httpService.asset = null;
              this.resetData();
            }
          )
        }

      }, 500)
    }
  }

  changeProductStatus() {
    this.radioButtonValue = 0;
    this.asset.attributes.productStatus = this.radioButtonValue;
  }

  validateAssetForm(): boolean {
    // debugger;
    if (this.asset.name.length == 0) {
      this.assetNameControl.setValue(null);
      return false;
    }
    this.isUploadClicked = true;
    let isValid = true;
    this.assetNameExists = this.httpService.newVersionFlag || this.httpService.newExtensionFlag || this.httpService.updateAssetFile ? false : this.assetNameCheck(this.asset.name);
    isValid = !this.assetNameExists && this.assetNameControl.valid && this.primaryContactNameControl.valid && this.primaryContactEmailControl.valid && !this.assetTagError;
    if (!this.asset.attributes.primaryContact.name || this.asset.attributes.primaryContact.name.trim() === '') {
      isValid = false;
      this.primaryContactNameControl.setValue('');
    }
    if (!this.asset.attributes.primaryContact.emailId || this.asset.attributes.primaryContact.emailId.trim() === '') {
      isValid = false;
      this.primaryContactEmailControl.setValue('');
    }
    if (!this.threeDfile) {
      isValid = false;
      this.noFilerError = true;
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].setAttribute('style', 'border:1px dotted red!important');
        } else {
          element.setAttribute('style', 'border:1px dotted red!important');
        }
      }
    } else {
      this.noFilerError = false;
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].removeAttribute('style');
        } else {
          element.removeAttribute('style');
        }
      }
    }
    return isValid;
  }

  togglePCDiv(event) {
    if (event.target.attributes.active) {
      this.showPrimaryContactDiv = true;
      this.asset.attributes.primaryContact.emailId = this.loggedInUser.userEmailId;
      this.primaryContactInfo.name = this.loggedInUser.name;
    } else {
      this.showPrimaryContactDiv = false;
      this.asset.attributes.primaryContact.name = '';
      this.asset.attributes.primaryContact.emailId = '';
    }
    this.primaryContactNameControl = new FormControl(this.asset.attributes.primaryContact.name, [Validators.required]);
    this.primaryContactEmailControl = new FormControl(this.asset.attributes.primaryContact.emailId, [Validators.email, Validators.required, Validators.pattern('.*@siemens-healthineers.com')]);
  }

  getFolderDetails() {
    if (!this.httpService.folder.assetList || this.httpService.folder.assetList.length === 0) {
      this.httpService.getFolderById(this.httpService.folder._id).subscribe(
        data => {
          this.currentFolderDetails = data;
        }
      );
    } else {
      this.currentFolderDetails = this.httpService.folder;
    }
  }

  assetNameCheck(assetName: string): boolean {
    if (this.currentFolderDetails && this.currentFolderDetails.assetList) {
      if (this.currentFolderDetails.assetList.find(x => x.name.toLowerCase() === assetName.toLowerCase())) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  fetchFileDetails() {
    this.httpService.fetchFiles(`${this.httpService.basePath}/asset/assetfiles/${this.asset._id}/${this.assetFile.versionNo}/${this.assetFile.specification.fileFormat}/${this.assetFile.specification.fileQuality}/${this.assetFile.specification.textureQuality}/${this.userService.loggendInUser.userEmailId}`)
      .subscribe(
        data => {
          data.forEach(file => {
            if (this.threeFileTypes.indexOf(file.split('.')[file.split('.').length - 1].toLowerCase()) > -1)
              this.threeDfile = new NgxFileDropEntry(file, null)
            else
              this.texturesFiles.push(new NgxFileDropEntry(file, null));
          });
        }, err => {
          console.error(err);
        }
      )
  }

  deleteFile(file, deldeteFrom) {
    // deldeteFrom.splice(deldeteFrom.indexOf(file), 1);
    // debugger;
    if (!this.httpService.updateAssetFile) {
      deldeteFrom.splice(deldeteFrom.indexOf(file), 1);
      return;
    }
    if (confirm("Are you sure you want to delete the file")) {
      this.httpService.deleteFile(`${this.httpService.basePath}/asset/assetfiles/${this.asset._id}/${this.assetFile.versionNo}/${this.assetFile.specification.fileFormat}/${this.assetFile.specification.fileQuality}/${this.assetFile.specification.textureQuality}/${file.relativePath}/${this.userService.loggendInUser.userEmailId}`).subscribe(
        data => {
          this.httpService.clear3DCache = true;
          deldeteFrom.splice(deldeteFrom.indexOf(file), 1);
        }, err => {
          console.error(err);
        }
      )
    }

  }

  deleteThreeDFile(file) {
    if (!this.httpService.updateAssetFile) {
      this.threeDfile = null;
      return;
    }
    if (confirm("Are you sure you want to delete the file")) {
      this.httpService.deleteFile(`${this.httpService.basePath}/asset/assetfiles/${this.asset._id}/${this.assetFile.versionNo}/${this.assetFile.specification.fileFormat}/${this.assetFile.specification.fileQuality}/${this.assetFile.specification.textureQuality}/${file.relativePath}/${this.userService.loggendInUser.userEmailId}`).subscribe(
        data => {
          this.httpService.clear3DCache = true;
          this.threeDfile = null;
        }, err => {
          console.error(err);
        }
      )
    }
  }

  resetData() {
    this.httpService.newExtensionFlag = false;
    this.httpService.newVersionFlag = false;
    this.httpService.updateAssetFile = false;
  }
  cancel() {
    this.httpService.asset = null;
    this.httpService.newVersionFlag = false;
    this.httpService.newExtensionFlag = false;
    this.httpService.updateAssetFile = false;
    this.router.navigateByUrl(`/val-assets/search/assets/${this.folderpath}/${this.asset._id}`);
  }

  /**
   * Method will be call once the browse button will be clicked.
   * @param event - Event on selecting any file through the browse button.
   */
  onFileSelected(event: any): void {
    this.getSelectedFolderDirectory(event);
  }

  /**
   * Function which will return the extension of the file after file has been browsed..
   * @param file - The file that is selected to upload
   */
  gettingExtensionOfFile(file) {
    const nameArray = file.name.split('.');
    const nameArrayLength = nameArray.length;
    const extension = (nameArray[nameArrayLength - 1]).toLowerCase();
    return extension;
  }
  /**
    * This method will be going to separate the files as 3d files and texture files or other files and generate the form data to upload the 3d model.
    */
  private getSelectedFolderDirectory(event: any): void {
    // this.input.nativeElement.value = '';
    const folderPaths: Array<any> = [];
    this.files = event.files;
    this.unsupportedFiles = [];
    let texturesFiles = [];
    let otherFiles = [];
    let all3DFiles = [];
    let extension = '';
    const filesArray = Object.values(event.target.files);
    // this.folderSelected.emit(folderPaths);
    console.log(event.target.files);
    if(filesArray.length>0){
      this.uploadEnable = false;
    }
    all3DFiles = (filesArray.filter(file => this.threeFileTypes.indexOf(this.gettingExtensionOfFile(file)) > -1));
    texturesFiles = (filesArray.filter(file => this.textureFilesFormats.indexOf(this.gettingExtensionOfFile(file)) > -1));
    this.unsupportedFiles = (filesArray.filter(file =>
      (this.threeFileTypes.indexOf(this.gettingExtensionOfFile(file)) <= -1 &&
        this.textureFilesFormats.indexOf(this.gettingExtensionOfFile(file)) <= -1)));
    this.assignFiles(texturesFiles, all3DFiles, otherFiles, event);
  }

  assignFiles(texturesFiles, all3DFiles, otherFiles, event) {
    this.unsupportedFiles = Array.from(new Set(this.unsupportedFiles));
    if (event.target.files.length > all3DFiles.length + texturesFiles.length + otherFiles.length) {
      texturesFiles = [];
      all3DFiles = new Array<NgxFileDropEntry>();
      document.getElementById('unsupported').setAttribute('visible', 'true');
    }

    if (this.texturesFiles.length === 0) {
      this.texturesFiles = texturesFiles;
    } else {
      this.texturesFiles = [...this.texturesFiles, ...texturesFiles];
    }

    if (all3DFiles.length === 1) {
      this.threeDfile = all3DFiles[0];
    }
    else if (all3DFiles.length > 1) {
      // alert("one 3d object per selection");
      document.getElementById('3D-file-warning').setAttribute('visible', 'true');
    }


    if (null !== this.threeDfile) {
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].removeAttribute('style');
        } else {
          element.removeAttribute('style');
        }
      }
    }
  }
  onInputClick(event) {
    event.target.value = '';
  }
  cancelUploadProcess() {
    document.querySelector('#modify-alert').setAttribute('visible', 'false');
    this.router.navigateByUrl(`/val-assets/search/assets/${this.folderpath}/${this.asset._id}`);
  }

  setupDelete(url: string) {
    this.deleteImg = url;
    let x = url.split('\\');
    this.deletePath = x[x.length - 1];
    document.querySelector('#imageToDelete').setAttribute('visible', 'true');
  }

  setupAdd() {
    document.querySelector('#imageToAdd').setAttribute('visible', 'true');
  }

  // downloadAllPreviewImages() {
  //   this.httpService.getPreviewImages(this.asset._id, this.userService.loggendInUser.userEmailId).subscribe((res) => {
  //     console.log("Downloading...");
  //     const blob = new Blob([res], {
  //       type: 'application/zip'
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     window.open(url);
  //   },
  //     (err) => {
  //       console.log("Error downloading the asset");
  //     });
  // }

  addImage() {
    const formData = new FormData();
    if (this.previewImage && this.previewImage.length > 0) {
      for (let i = 0; i < this.previewImage.length; i++) {
        formData.append('previewImages', this.previewImage[i], this.previewImage[i].name);
      }
    }
    console.log(this.previewImage);
    this.httpService.addPreviewImages(this.asset._id, this.loggedInUser.userEmailId, formData).subscribe((res:any) => {
      console.log(res);
      this.selectedPreviewImages = res;
      this.selectedPreviewImages = this.selectedPreviewImages.map(item => {
        item = 'assets\\' + item;
        return item;
      });
      // this.fetch3DImages();
    },
      (err) => {
        alert("error occurred");
      },
      () => {
        this.previewImage = [];
        this.preview = [];
      });
  }

  clearImgSelection(){
    this.previewImage = [];
    this.preview = [];
    this.selectedPreviewImages = JSON.parse(JSON.stringify(this.modifiedPreviewImages));
  }

  deleteImage() {
    console.log(typeof(this.deletePath));
    this.httpService.deletePreviewImages(this.asset._id, this.loggedInUser.userEmailId, this.deletePath).subscribe((res) => {
      this.selectedPreviewImages = this.selectedPreviewImages.filter(img => img !== this.deleteImg);
      alert(this.deletePath + ' deleted!');
    },
      (err) => {
        console.log('some error occured');
      });
  }

  openBrowseWindow() {
    document.getElementById('browseFile').click();
  }

  selectPreviewImage(event) {
    //2097152
    //3145728

    this.modifiedPreviewImages = JSON.parse(JSON.stringify(this.selectedPreviewImages));
    let minWidth: number = 1280;
    let minHeight: number = 1024;
    let maxSize: number = 2097152;
    let previewImage: FileList = event.target.files;
    if (previewImage.length > 0 && previewImage.length<= 10 && previewImage.length <= (10 - this.selectedPreviewImages.length)) {
      if (this.selectedPreviewImages && this.selectedPreviewImages.length < 10) {
        for (let i = 0; i < previewImage.length; i++) {
          if (this.selectedPreviewImages.findIndex(x => x.includes(previewImage[i].name))>-1 || this.preview.findIndex(x => x.file.name === previewImage[i].name) > -1) {
            alert(previewImage[i].name + " already selected/uploaded");
            return true;
          }

          if (this.supportedImageFormats.indexOf(previewImage[i].name.split('.')[previewImage[i].name.split('.').length - 1].toLowerCase()) == -1
            || previewImage[i].size > maxSize) {
            document.getElementById('unsupported-image').setAttribute('visible', 'true');
            this.unsupportedImageErrorMessage = "Please upload image(less than 2MB) with image resolution of 1280 x 1024 px or higher.";
            return true;
          }
          let reader = new FileReader();

          reader.onload = (e: any) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = rs => {

              if (img.height < minHeight || img.width < minWidth) {
                //console.log(5, img_height + 'x' + img_width);
                this.unsupportedImageErrorMessage = "Please upload image(less than 2MB) with image resolution of 1280 x 1024 px or higher.";
                document.getElementById('unsupported-image').setAttribute('visible', 'true');
                return true;
              }
              else {
                this.selectedPreviewImages.push(e.target.result);
                this.previewImage.push(previewImage[i]);
                this.preview.push({'file':previewImage[i],'src':e.target.result});
              }

            }
          }
          reader.readAsDataURL(previewImage[i]);
        }

      }
    }
    else {
      document.getElementById('unsupported-image').setAttribute('visible', 'true');
      this.unsupportedImageErrorMessage = "Please upload upto 10 image(less than 2MB) only.";
    }

    console.log(previewImage);
  }
}
